<template>
  <el-table-column
    prop="product.name"
    label="Termék"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      <el-link type="primary" @click="$router.replace('/processes/packings/view/' + scope.row.id)">
        {{ scope.row.product.name }}
      </el-link>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'product.name',
  };
</script>
